import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ISubscription } from 'rxjs-compat/Subscription';
import { FooterLinks } from '../../models/footer-links';
import { CommonService } from '../services/common.service';
declare let fbq:Function;


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  $footerSubscription:ISubscription;
  emailAddress:any='';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  
  isSuccess:boolean=false;
  isValidFormSubmitted = false;  
  nameSub: string;
  nameSubCheck: boolean =false;
  constructor(private _router: Router,private _common:CommonService) { }
  links:FooterLinks[]=null;
  ngOnInit() {
    this.getAllfooterLinks();
  }

  onFormSubmit(form: NgForm) {  
    this.isValidFormSubmitted = false;  
debugger;
    setTimeout(() => {
      if (typeof fbq === 'function') {
        fbq('track', 'Purchase', {
          value: 500,
          content_ids: 'EUR',
        });
        console.log('Facebook Pixel Purchase event fired:', { value: 500, content_ids: 'EUR' });
      } else {
        console.error('Facebook Pixel is not loaded.');
      }
    }, 4000);


    if (form.invalid) {  
       return;  
    }  
    if(this.nameSub == null || this.emailAddress == null)
    {
      this.nameSubCheck=true;
      return;
    }
    this._common.subscribeNewsLetter(this.emailAddress, this.nameSub).subscribe((response:any)=>{
     this.isSuccess = true;
    })
    this.isValidFormSubmitted = true; 
    this.nameSubCheck = false; 
    form.resetForm();  
 }  


  redirectToFAQ() {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/faq'])
    );
    window.open(url, '_blank');
  }

  redirectToAbout() {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/aboutus'])
    );
    window.open(url, '_blank');
  }

  redirectToContact() {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/contacts'])
    );
    window.open(url, '_blank');
  }

  subscribeNewsletter(){

  }

  getAllfooterLinks(){
    this.$footerSubscription = this._common.getFooterLinks().subscribe((response:FooterLinks[]) =>{
      this.links = response;
    })
  }

  ngOnDestroy() {
    if(this.$footerSubscription){this.$footerSubscription.unsubscribe();}
  }


}
